import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../assets/css/styles.css';
const axios = require('axios').default;
var config = require('../../config/config.json');


export default function TeacherDashboard(props) {
  document.title = props.title;
  var retrievedUserDetailsObject = JSON.parse(localStorage.getItem('userDetailsLog'));


  const [userLoginDetails, setLoginDetailsValue] = useState(retrievedUserDetailsObject);
  const [feedbackVisibilityDetails, setFeedbackVisibilityDetails] = useState("");
  const [submittedFeedbackDetails, setSubmittedFeedbackDetails] = useState("");

  const [userDesignation, setUserDesignation] = useState(userLoginDetails.mstr_teacher_designation);
  const [userNatureofAppointment, setUserNatureofAppointment] = useState(userLoginDetails.mstr_teacher_nature_of_oppintment);
  const [userDepartment, setUserDepartment] = useState(userLoginDetails.mstr_teacher_department);
  const [userYearofExperience, setUserYearofExperience] = useState(userLoginDetails.mstr_teacher_year_of_experience);
  const [userContactNumber, setUserContactNumber] = useState(userLoginDetails.mstr_teacher_contact);


  console.log('userDetailsLog: ', userLoginDetails);
  const navigate = useNavigate();

  useEffect(() => {
    getFeedbackVisibility();
    getFeedbackSubmittedStatus();
  }, []);

  function getFeedbackSubmittedStatus() {
    axios.post(config.API_URL + 'getSubmittedFeedbackDetails', {
      userId: userLoginDetails.LoginUserId,
      userRole: userLoginDetails.role_master_auto_id,
      currentAcademicYear: userLoginDetails.currentAcademicYear,
      classSemester: ""
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {
        if (response.data.data != null && response.data.data != "") {
          setSubmittedFeedbackDetails(response.data.data);
        } else {
          setSubmittedFeedbackDetails("");
        }
      }
    }).catch(function (error) {
      toast.error(error);
    });
  }

  function getFeedbackVisibility() {
    axios.post(config.API_URL + 'getFeedbackVisibilityDetails', {
      userRole: userLoginDetails.role_master_auto_id
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {
        if (response.data.data != null && response.data.data != "") {
          setFeedbackVisibilityDetails(response.data.data);
        } else {
          setFeedbackVisibilityDetails("");
        }
      }
    }).catch(function (error) {
      toast(error);
    });
  }

  function onFeedbackSelectSubmitClick(feedbackLink) {
    var filter = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
    if (userDesignation) {
      if (userNatureofAppointment) {
        if (userDepartment) {
          if (userContactNumber) {
            if (filter.test(userContactNumber) && userContactNumber.length == 10) {
              if (userYearofExperience) {
                axios.post(config.API_URL + 'updateTeacherPersonalInfromation', {
                  userId: userLoginDetails.LoginUserId,
                  userDesignation: userDesignation,
                  userNatureofAppointment: userNatureofAppointment,
                  userDepartment: userDepartment,
                  userYearofExperience: userYearofExperience,
                  userContactNumber: userContactNumber,
                }, {
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
                }).then(function (response) {
                  if (response.data.status.status == 1) {
                    userLoginDetails.mstr_teacher_designation = userDesignation;
                    userLoginDetails.mstr_teacher_nature_of_oppintment = userNatureofAppointment;
                    userLoginDetails.mstr_teacher_department = userDepartment;
                    userLoginDetails.mstr_teacher_year_of_experience = userYearofExperience;
                    localStorage.setItem('userDetailsLog', JSON.stringify(userLoginDetails));
                    navigate(feedbackLink);
                  }
                }).catch(function (error) {
                  toast.error(error);
                });
              } else {
                toast.warning("Please select a year of experience");
              }
            } else {
              toast.warning("Please enter 10  digit mobile number");
            }
          } else {
            toast.warning("Please enter your 10 digit contact number");
          }
        } else {
          toast.warning("Please enter department name");
        }
      } else {
        toast.warning("Please select nature of appointment");
      }
    } else {
      toast.warning("Please enter designation");
    }
  }

  function clickOnLogOut() {
    localStorage.removeItem("userDetailsLog");
    localStorage.removeItem("isAuthenticated");
    localStorage.clear();
    navigate('/');
  }

  const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;
  return (
    <div className="index-cover">
      <div className="container main-container">
        <section className='section-header' >
          <div className='row'><div className="col-md-12" >
            <div className='logout-strip'>
              <div className='link-holder'>
                <a className="btn-link" type="button">Welcome {userLoginDetails.mstr_student_teacher_first_name}&nbsp;{userLoginDetails.mstr_student_teacher_last_name}&nbsp;</a>
                <span className='line-divider'></span>
                <a className="btn-link" type="button" onClick={clickOnLogOut}>Logout</a>
              </div>
            </div>
            <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
            <div className='feedback-title' >Teacher Feedback</div>
          </div>
          </div>
        </section>

        <section className='section-userInformation'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='note note-thankyou'>
                <span style={{ display: 'block', marginBottom: '10px' }}>Dear {userLoginDetails.mstr_student_teacher_first_name},  </span>Thank you for your engagement as a faculty with {config.collegeName}. You are an integral part of the {config.collegeName} family. We are carrying out a survey to receive feedback from Faculty. Read the questions and answer accordingly.</div>
            </div>
          </div>
          <div className='row'>

            <div className="form-group col-md-6">
              <label htmlFor="name">Name of the Teacher<em>*</em></label>
              <input type="text" className="form-control" id="exampleInputEmail1" defaultValue={userLoginDetails.mstr_student_teacher_first_name + " " + userLoginDetails.mstr_student__teacher_middle_name + " " + userLoginDetails.mstr_student_teacher_last_name} placeholder="Enter Name" disabled />
            </div>

            <div className="form-group col-md-6">
              <label htmlFor="name">Email address<em>*</em></label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="Enter Email address" defaultValue={userLoginDetails.mstr_student_teacher_email} disabled />
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="designation">Designation<em>*</em></label>
              <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" onChange={(e) => setUserDesignation(e.target.value)} defaultValue={userDesignation} placeholder="Enter your designation" />
            </div>

            <div className="form-group  col-md-4">
              <label htmlFor="">Nature of Appointment <em>*</em></label>
              <select name="appointment" className="form-control" defaultValue={userNatureofAppointment} onChange={(e) => setUserNatureofAppointment(e.target.value)}>
                <option value="">-- Select--</option>
                <option value="Permanent">Permanent</option>
                <option value="Ad-hoc">Ad-hoc</option>
                <option value="Guest">Guest</option>

              </select>
            </div>

            <div className="form-group  col-md-4">
              <label htmlFor="">Department <em>*</em> </label>
              <select name="department" id="exampleInputEmail1" className="form-control" value={userDepartment} onChange={(e) => setUserDepartment(e.target.value)}>
                <option value="">-- Select Department name--</option>
                <option value="F&N">F&N</option>
                <option value="HDSC">HDSC</option>
                <option value="FAS">FAS</option>
                <option value="DCE">DCE</option>
                <option value="RMDA">RMDA</option>
                <option value="Dept. of Education">Dept. of Education</option>
                <option value="Dept. of English">Dept. of English</option>
                <option value="Dept. of Science">Dept. of Science</option>
              </select>
              {/* <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" onChange={(e) => setUserDepartment(e.target.value)} defaultValue={userDepartment} placeholder="Enter department name" /> */}
            </div>

            <div className="form-group col-md-6">
              <label htmlFor="name">Contact Number<em>*</em></label>
              <input type="text" minLength="10" maxLength="10" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" onChange={(e) => setUserContactNumber(e.target.value)} defaultValue={userContactNumber} placeholder="Enter your contact number" />
            </div>

            <div className="form-group col-md-6">
              <label htmlFor="years">How many years have you been teaching in {config.collegeName} </label>
              <select name="appointment" className="form-control" onChange={(e) => setUserYearofExperience(e.target.value)} defaultValue={userYearofExperience}>
                <option value="0">Select a year of experience</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
              </select>
              {/* <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" onChange={(e) => setUserYearofExperience(e.target.value)} defaultValue={userYearofExperience} placeholder="No of years" /> */}
            </div>



          </div>

          <div className='row'>
            <div className='row-feedbackbox '>
              {feedbackVisibilityDetails.split(',').includes('Teacher') == true ?
                (submittedFeedbackDetails.split(',').includes('Teacher') == false ?
                  <div className="col-md-12">
                    {/* <div className='box-feedback' >
                       <span className='number'>1</span><h4>Teacher Feedback  </h4> */}
                    <button className='btn btn-primary btn-startSurvey btn-block' onClick={() => onFeedbackSelectSubmitClick('/TeacherFeedback')}>Take up Survey</button>
                    {/* </div> */}
                  </div>
                  :
                  <div className="col-md-4">
                    <div className="box-feedback submitted">
                      <span className='status'>Submitted</span>
                      <h4> Teacher Feedback</h4>
                      <button className="btn btn-primary btn-block">Submitted</button>
                    </div>
                  </div>
                )
                : null}
            </div>
          </div>
        </section>
        <section className='section-footer'>
          <div className='row'>
            <div className='footer'>
              <div className='col-md-6 col-sm-6' >{config.collegeName}, Feedback System {config.version}</div>
              <div className='col-md-6 col-sm-6 text-poweredBy'>{config.PoweredBy}</div>
            </div>
          </div>
        </section>
      </div>
      <ToastContainer />
    </div>
  )
}